import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./Nav";
import { PLANS, hasAccess } from "../mock";

const MemberDash = () => {
  const { user, loading, logout, setCheckoutPlan } = useAuth();
  const nav = useNavigate();
  if (loading) return <div id="memberDash" />;
  if (!user) return <Navigate to="/" replace />;
  const active = hasAccess(user);
  const plan = PLANS.find((p) => p.id === user.plan);
  const left = user.plan_expires ? Math.max(0, Math.ceil((new Date(user.plan_expires) - Date.now()) / 3600000)) : null;

  return (
    <div id="memberDash" data-testid="member-dash">
      <div className="dash-nav">
        <Logo />
        <div className="dash-nav-r">
          <span className="dash-name" data-testid="dash-name">{user.name}</span>
          <button className="nav-btn nb-login" onClick={() => { logout(); nav("/"); }} data-testid="logout-btn">Logout</button>
        </div>
      </div>
      <div className="dash-body">
        {active ? (
          <>
            <div className="dash-eye">{user.role === "owner" ? "Owner · Unlimited Access" : <>Active Member · {plan?.name || (user.plan === "lifetime" ? "Lifetime" : "")}{left !== null && user.plan !== "monthly" ? ` · ${left >= 24 ? Math.floor(left / 24) + "d " + (left % 24) + "h" : left + "h"} left` : ""}</>}</div>
            <h2>Welcome back.<br /><em>Your edge is ready.</em></h2>
            <p>The AI Scanner is hunting setups across 31 markets. Open it below.</p>
            <button className="dash-btn" onClick={() => nav("/scanner")} data-testid="open-scanner-btn">Open AI Scanner →</button>
            <div><button className="dash-btn ghost" onClick={() => nav("/live")} data-testid="open-live-btn">Live Indicator →</button></div>
            {user.role === "owner" && <div><button className="dash-btn ghost" onClick={() => nav("/admin")} data-testid="open-admin-btn">Owner Panel →</button></div>}
          </>
        ) : (
          <>
            <div className="dash-eye">{user.plan ? "Plan Expired" : "No Active Plan"}</div>
            <h2>Almost there.<br /><em>Unlock your edge.</em></h2>
            <p>Choose a plan to unlock the AI Scanner on your account.</p>
            <div className="dash-plans">
              {PLANS.map((p) => (
                <button key={p.id} className={`dash-plan ${p.featured ? "feat" : ""}`} onClick={() => setCheckoutPlan(p)} disabled={p.id === "trial" && user.trial_used} data-testid={`dash-plan-${p.id}`}>
                  <span>{p.name}</span><b>${p.price}</b>
                  {p.id === "trial" && user.trial_used && <small>Used</small>}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MemberDash;
